export const FIND_EMPLOYEE_SUCCESS = 'FIND_EMPLOYEE_SUCCESS';

export const findEmployeeSuccess = employee => ({
    type: FIND_EMPLOYEE_SUCCESS,
    payload: { employee },
});
